import React from 'react'
import { clients } from '../../constants'

function Clients() {
  const [index, setIndex] = React.useState(0);
  const timeoutRef = React.useRef(null);
  const delay = 2500;

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  React.useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === clients.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index]);
  return (
    <section id="clients">
      <div className="container text-center" data-aos="fade-right" data-aos-duration="1000">
        <h2 className='mb-5'>Dipercaya <span className="text-warning">1000+</span> Oleh Pelanggan Kami di Seluruh Indonesia</h2>
        <div className="row justify-content-center align-items-center">
          {clients.map((client, idx) => {
            return(
              <div className="col-4 col-lg-3" key={idx} data-aos="fade-left" data-aos-duration="1000">
                <img src={client} alt="imageClient" className='imgClient my-4'/>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Clients